import config from 'crm/config'

const profileApi = `${config.apiHost}/oem-profile`

export default {
    list: {
        url: `${profileApi}/api/mpa`,
        type: 'GET',
    },
    create: {
        url: `${profileApi}/api/mpa`,
        type: 'POST',
    },
    update: {
        url: `${profileApi}/api/mpa/{id}`,
        type: 'PUT',
    },
    remove: {
        url: `${profileApi}/api/mpa/{id}`,
        type: 'DELETE',
    },
}
